class LqdCFHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initFormInputs();

  }

  getDefaultSettings() {
    return {
      selectors: {
        formElement: 'form',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $formElement: this.$element.find(selectors.formElement),
    }
  }

  initFormInputs() {

    this.elements.$formElement.liquidFormInputs();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdCFHandler, { $element } );
};